import type { GridFilterItem } from '@mui/x-data-grid-pro';

const OPERATORS_WITHOUT_VALUE = new Set([
  'isEmpty',
  'isNotEmpty',
]);

export const isEmptyFilterValue = (value: unknown): boolean =>
  value === undefined || value === null || value === '';

export const hasNonEmptyFilterValue = (value: unknown): boolean => {
  if (Array.isArray(value)) {
    return value.some((entry) => !isEmptyFilterValue(entry));
  }

  return !isEmptyFilterValue(value);
};

export const isActiveFilterItem = (item: GridFilterItem): boolean => {
  if (!item.field || !item.operator) {
    return false;
  }

  if (OPERATORS_WITHOUT_VALUE.has(item.operator)) {
    return true;
  }

  return hasNonEmptyFilterValue(item.value);
};
